export class OrderHeader {
	id?: string;

	advertiserId?: string;
	advertiserName?: string;
	otherPayerId?: string;
	otherPayerName?: string;

	invoiceDescription?: string;
	poNumber?: string;

	packageLabels?: string[];
	productLabels?: string[];
	placementLabels?: string[];
	sizeLabels?: string[];

	priceNetExComm?: number;
	commissionAmount?: number;
	priceNetExTax?: number;
	taxAmount?: number;
	priceNetIncTax?: number;
	paidAmount?: number;

	statusFlags?: string[];
	statusCounts?: {};

	thumbnail?: string;

	startDate?: string;
	endDate?: string;
	nextDate?: string;

	adCount!: number;
	adCountRemaining!: number;

	contactFirstName?: string;
	contactLastName?: string;
	contactPhone?: string;

	// contactId ?
	agencyContactId?: string;
	campaignName?: string;

	orderNumber?: string;
	bookedDate?: string;
	customerContact?: string;
	contactEmail?: string;
	materialAgency?: string;
	materialAgencyContact?: string;
	pubDates?: number;

	externalPlanId?: string
}
